import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HrefDirective, HrefParams } from '../../directives/href/href.directive';
import { HrefPipe } from '../../pipes/href.pipe';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-unsupported',
  templateUrl: 'unsupported.component.html',
  styleUrls: ['unsupported.component.scss'],
  imports: [
    HrefDirective,
    TranslateModule,
    HrefPipe,
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsupportedBrowserComponent {
  @Input() to: string;
  @Input() params: HrefParams;
}
